// import {

import {
  FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES,
  FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING,
  FETCH_ALL_FORECAST_SCHEDULES,
  FETCH_ALL_FORECAST_SCHEDULES_LOADING,
  UPDATE_DELIVERY_SCHEDULE_FORECAST,
} from "../../actions/types";

//   } from "../../actions/types";

const intialState = { backdropText: "Please wait..." };

export default function (state = intialState, action) {
  switch (action.type) {
    case FETCH_ALL_FORECAST_SCHEDULES_LOADING:
      return {
        ...state,
        forecastSchedulesLoading: action.payload,
      };
    case FETCH_ALL_FORECAST_SCHEDULES:
      return {
        ...state,
        forecastSchedules: action.payload,
      };
    case UPDATE_DELIVERY_SCHEDULE_FORECAST:
      return {
        ...state,
        updateDeliveryScheduleForecastData: action.payload,
      };
    case FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES:
      return {
        ...state,
        forecastScheduleApprovalRoles: action.payload,
      };
    case FETCH_ALL_FORECAST_SCHEDULE_APPROVAL_ROLES_LOADING:
      return {
        ...state,
        forecastScheduleApprovalRolesLoading: action.payload,
      };
    default:
      return state;
  }
}
